import {Controller} from "@hotwired/stimulus"

import {Collapse} from "bootstrap";

// Connects to data-controller="anchor-scroll"
export default class extends Controller {
  connect() {
    if (this.element.hash) {
      this.element.addEventListener("click", (e) => this.onClick(e));

      if (location.hash === this.element.hash) this.scrollToElement();
    }
  }

  onClick(e) {
    e.preventDefault();

    this.scrollToElement();
  }

  getTargetElement() {
    return document.getElementById(this.element.hash.replace("#", ""));
  }

  scrollToElement() {
    const targetElement = this.getTargetElement();

    if (targetElement) {
      this._scrollToElement(targetElement, this.getParentAccordions(targetElement));
    }
  }

  _scrollToElement(targetElement, accordions = []) {
    if (accordions.length > 0) {
      const accordionEl = accordions.shift();
      const accordion = Collapse.getOrCreateInstance(accordionEl, {toggle: false});
      if (!accordion._isShown()) {
        accordionEl.addEventListener("shown.bs.collapse", () => this._scrollToElement(targetElement, accordions));
        accordion.show();
        return;
      }
    }

    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start"
    });
  }

  getParentAccordions(element) {
    const accordions = [];

    let accordion = element.parentNode.closest(".collapse");
    while (accordion) {
      accordions.push(accordion);
      accordion = accordion.parentNode.closest(".collapse");
    }

    return accordions;
  }
}
